import { template } from 'lodash';
import translations from './translations-service';

const interpolate = /{([\s\S]+?)}/g;

const t = (key, params) => {
  const translationsMap = translations.get();
  return template(translationsMap[key], { interpolate })(params) || key;
};

export default {
  t,
};
